import { AssetTag } from '../TableHeaderTags/TableHeaderTags.types'

export enum TagsPopoutView {
  LIST = 'list',
  CREATE = 'create',
  EDIT = 'edit',
}

export interface CreateTagScreenProps {
  onBack: () => void
  onTagCreated: (tag: AssetTag) => void
  assetId?: string | number
}

export interface EditTagScreenProps {
  tag: AssetTag
  onBack: () => void
  onTagUpdated: (tag: AssetTag) => void
  onTagDeleted: (tagId: number) => void
}

export interface ColorPickerProps {
  value: string
  onChange: (color: string) => void
  label?: string
  disabled?: boolean
  dataTestId?: string
}

export interface TagItemProps {
  tag: AssetTag
  isSelected: boolean
  isTagsUpdating: boolean
  disabled?: boolean
  onToggle: (tagId: number, isSelected: boolean, tag: AssetTag) => void
  onEdit?: (tag: AssetTag) => void
}

export interface TagsListViewProps {
  searchFilteredTags: AssetTag[]
  searchTerm: string
  onSearchChange: (term: string) => void
  currentAssetTags: AssetTag[]
  isTagsUpdating: boolean
  onCreateNewTag: () => void
  onEditTag?: (tag: AssetTag) => void
  onOpenModal: () => void
  onClose: () => void
}

export interface TagsPopoutState {
  currentView: TagsPopoutView
  searchTerm: string
  localSelectedTagIds: string[]
}
